<template>
  <div class="systemSetting">
    <div class="subHead">
      <van-icon name="arrow-left" class="arrow" @click="goBack" />
      <span class="subHead-text">{{ subHead }}</span>
    </div>
    <van-cell-group>
      <van-cell title="解绑微信" is-link @click="unbind" />
<!--      <van-cell title="关于我们" is-link to="aboutUs" />-->
      <van-cell title="软件版本" value="V1.9.0" @click="showVc" />
    </van-cell-group>
  </div>
</template>

<script>
import { Row, Col, Icon, Cell, CellGroup, Dialog } from 'vant';
import { GetUserInfo, StaffUnbind, VisitorUnbind } from '@/api/user';
import Cookies from 'js-cookie';
import { Toast } from 'vant';

export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup

  },
  data() {
    return {
      subHead: '设置',
      lastClickTime: 0,
      count: 0
    };
  },
  methods: {

    goBack() {
      this.$router.go(-1);
    },

    unbind() {
      // this.showCancleDialog = true
      Dialog.confirm({
        title: '温馨提示',
        message: '解绑微信后将不能再使用访客功能，确认解绑？',
        messageAlign: 'left'
      }).then(() => {
        this.personalInfo = JSON.parse(
          localStorage.getItem('personalInfo') || '{}'
        );
        switch (this.personalInfo.staff) {
          case false:
            this.visitorUnbind();
            break;
          case true:
            this.staffUnbind();
            break;
          default:
            break;
        }
      }).catch(() => {
        // on cancel
      });
    },
    // 访客解绑微信
    visitorUnbind() {
      const data = {};
      VisitorUnbind(data).then(response => {
        Cookies.set('token', '', -1, '/');
        Cookies.set('secret', '', -1, '/');
        localStorage.removeItem('personalInfo');
        this.$router.push({ name: 'bind' });
        Toast.clear();
      });
    },
    // 员工解绑微信
    staffUnbind() {
      const data = {};
      StaffUnbind(data).then(response => {
        // Cookies.set('token', '', -1, '/')
        // Cookies.set('secret', '', -1, '/')
        localStorage.removeItem('personalInfo')
        const data = {}
        GetUserInfo(data).then(response => {
          if (response.data) {
            this.personalInfo = response.data
            localStorage.setItem('personalInfo', JSON.stringify(this.personalInfo))
            this.$router.push({ path: '/home' })
            Toast.clear();
          }
        })
      });
    },
    hasClass(obj, cls) {
      return obj.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
    },
    addClass(obj, cls) {
      if (!this.hasClass(obj, cls)) obj.className += ' ' + cls
    },
    showVc() {
      const nowTime = new Date().getTime()
      // if (nowTime - this.lastClickTime < 3000) {

      // } else {
      //   this.count = 0
      // }
      this.count++
      this.lastClickTime = nowTime
      if (this.count >= 4) {
        const vconDom = document.getElementById('__vconsole')
        this.addClass(vconDom, 'vcshow')
        this.count = 0
      }
    }

  }
};
</script>

<style lang="less" scoped>
</style>
